import {
  cloneDeep, find, findIndex, get, remove, set, sortBy,
} from 'lodash';
import { TimeFormatType } from '../../../../../common/components/TimeFormat/TimeFormat';
import {
  MERGE_TPM_CHARGER_METRICS,
  SET_TPM_CHARGER_METRICS,
  SET_TPM_LOADED_CHARGERS,
  SET_TPM_SELECTED_CHARGERS,
  SET_TPM_SHOW_RETRY_ICON_ON_SELECTED_CHARGERS,
  SET_TPM_TIME_OFFSET_TYPE,
} from './actions';
import { convertChargerPhaseValues } from '../../../../PlazaView/helper';

const defaultState = {
  powerMonitoring: {
    timeOffsetType: TimeFormatType.USER,
    chargers: {
      loaded: [],
      selected: [],
    },
    chargerMetrics: [],
  },
};

export const TelemetryReportsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_TPM_LOADED_CHARGERS: {
      const sorted = sortBy(action.payload, 'uuid');

      return set(cloneDeep(state), 'powerMonitoring.chargers.loaded', sorted);
    }
    case SET_TPM_SELECTED_CHARGERS: {
      const newState = cloneDeep(state);
      const selected = get(newState, 'powerMonitoring.chargers.selected');
      const chargerMetrics = get(newState, 'powerMonitoring.chargerMetrics');

      remove(chargerMetrics, (metric) => findIndex(selected, (charger) => charger.uuid === metric.chargerUuid) === -1);

      return set(newState, 'powerMonitoring.chargers.selected', action.payload);
    }

    case SET_TPM_CHARGER_METRICS: {
      const metrics = [];

      for (const { chargerName, metrics: chargerMetrics } of action.payload) {
        metrics.push({
          chargerName,
          metrics: Object.values(chargerMetrics).map((item) => ({
            ...item,
            value: convertChargerPhaseValues(item.value),
            allMetrics: item.allMetrics.map((phase) => ({
              ...phase, value: convertChargerPhaseValues(phase.value),
            })),
          })),
        });
      }

      return set(state, 'powerMonitoring.chargerMetrics', metrics);
    }

    case MERGE_TPM_CHARGER_METRICS: {
      const metrics = get(cloneDeep(state), 'powerMonitoring.chargerMetrics', []);

      for (const chargerName in action.payload) {
        const charger = find(metrics, { chargerName });

        if (!charger) {
          metrics.push({
            chargerName,
            metrics: action.payload[chargerName],
          });
        } else {
          const chargerMetrics = charger.metrics;

          for (const { ts, value, allMetrics } of action.payload[chargerName]) {
            const item = find(chargerMetrics, (item) => item.ts === ts);

            if (!item) {
              chargerMetrics.push({ ts, value, allMetrics });
            }
          }
        }
      }

      return set(state, 'powerMonitoring.chargerMetrics', metrics);
    }

    case SET_TPM_TIME_OFFSET_TYPE:
      return set(cloneDeep(state), 'powerMonitoring.timeOffsetType', action.payload);

    case SET_TPM_SHOW_RETRY_ICON_ON_SELECTED_CHARGERS: {
      const { chargerIds, value } = action.payload;
      const selectedChargers = get(state, 'powerMonitoring.chargers.selected', []);

      selectedChargers.forEach((charger) => {
        if (chargerIds.indexOf(charger.uuid) > -1) {
          charger.isError = value;
        }
      });

      return {
        ...state,
        powerMonitoring: {
          ...state.powerMonitoring,
          chargers: {
            ...state.powerMonitoring.chargers,
            selected: selectedChargers,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default TelemetryReportsReducer;
